import { Fragment, useEffect, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'


const DropDown = ({ dataList, firstSelected, selected, setSelected }) => {

    useEffect(() => {
        if (firstSelected) {
            setSelected(firstSelected);
        }
    }, [firstSelected]);

    return (
        <div className="w-60">
            <Listbox value={selected} onChange={setSelected}>
                <div className="relative">
                    <Listbox.Button className="relative w-full text-gray-900 cursor-pointer bg-gray-100 py-2 pl-3 pr-10 text-left  focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm rounded border-0 outline-0 shadow">
                        <span className="block truncate capitalize">{selected?.companyName}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronUpDownIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </span>
                    </Listbox.Button>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto
                         bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm capitalize">
                            {dataList.map((data) => (
                                <Listbox.Option
                                    key={data?._id}
                                    className={({ active }) =>
                                        `relative select-none py-2 pl-10 pr-4 cursor-pointer capitalize ${active ? 'bg-amber-100 text-[#E53E14]' : 'text-black'}`
                                    }
                                    value={data}
                                >
                                    {({ selected }) => (
                                        <>
                                            <span
                                                className={`block truncate capitalize ${selected ? 'font-medium' : 'font-normal'}`}
                                            >
                                                {data?.companyName}
                                            </span>
                                            {selected ? (
                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                </span>
                                            ) : null}
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
        </div>
    )
};

export default DropDown;
